<template>
  <v-card-text>
 <v-row>
   <v-col style="height: 97vh;overflow: auto" cols="12 col-md-4 col-sm-6">
     <div class="chats">
       <!--      <div class="search-bar">-->
       <!--        <v-text-field-->
       <!--          placeholder="جستجو در لیست"-->
       <!--          v-model="searchQuery"-->
       <!--          solo-->
       <!--        ></v-text-field>-->
       <!--      </div>-->

       <div class="chat-list" v-for="item in fConversations" :key="item.GetReceiver">
         <!--        <div class="chat-prev"  v-on:click="goToDetail(item)" @contextmenu="openMenu">-->
         <!--        <div class="chat-prev" @contextmenu="openMenu($event, item)" v-on:click="goToDetail(item)">-->
         <div class="chat-prev"  v-on:click="goToDetail(item)">

           <div class="row">
             <div class="col-2">
               <img :src="item.ProcessThumb"/>
             </div>
             <div class="col-10">
            <span class="time">
              {{get_conversation_date(item)}}
            </span>
               <span class="count" v-if="item.UnReadCount != 0 && item.UnReadCount < 100">
              {{item.UnReadCount}}
            </span>
               <span class="count" v-if="item.UnReadCount != 0 && item.UnReadCount >= 100">
              +99
            </span>
               <span class="name">
                  {{item.ProcessName}}
            </span>
               <span v-if="item.typing_text == null" class="text">
              {{item.MessageText}}
                 <!--                {{ long }}-->
              </span>
               <span v-else class="text">
              {{item.typing_text}}
                 <!--                {{ long }}-->
              </span>
               <v-menu
                 v-model="showMenu"
                 :position-x="x"
                 :position-y="y"
                 absolute
                 offset-y
               >
                 <v-list>

                   <v-list-item>
                     <v-list-item-title>
                      <span v-on:click="goToDetail(show_detail)">
                        {{ $t('show') }}
                      </span>
                     </v-list-item-title>
                   </v-list-item>
                   <v-list-item>
                     <v-list-item-title>
                      <span v-on:click="removeMessage()">
                        {{ $t('deleteMessage') }}
                      </span>
                     </v-list-item-title>
                   </v-list-item>
                 </v-list>
               </v-menu>


             </div>
           </div>

         </div>

       </div>
       <div class="start-conversation" v-on:click="goToContact()">
         <v-icon>
           mdi-chat-processing-outline
         </v-icon>

       </div>
     </div>

   </v-col>
   <v-col cols=" col-md-8 col-sm-6">
     <div v-if="!isMobile">
       <ChatDetail/>
     </div>
   </v-col>
 </v-row>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card class="remove-card">

        <v-card-text>
          {{ $t('deleteths') }}
        </v-card-text>
        <v-card-actions>

          <v-btn
            class="accept-btn"
            text
            @click="dialog = false"
          >
            {{ $t('ok') }}
          </v-btn>
          <v-btn
            class="cancle-btn"
            text
            @click="dialog = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</template>
<script>
  import Longpress from 'vue-longpress'
  import {bus} from '../../main.js'
  import Vue from 'vue'
import ChatDetail from "./ChatDetail";
  export default {
    data() {
      return {
        conversations: [],
        fConversations: [],
        date_now: '',
        searchQuery: null,
        long: 0,
        startTime: 0,
        endTime: 0,
        showMenu: false,
        dialog: false,
        show_detail: '',
        cnt: 1,
        x: 0,
        y: 0,
        isMobile:false,

      }
    },
    components: {
      Longpress,
      ChatDetail,

    },
    mounted() {
      this.get_all_conversations(1);
      bus.$on('signalr_methods', (data) => {
        // console.log(this.GetReceiver)
        // console.log(data[1].sender)
        if (data[0] == 'is_typing') {
          this.fConversations.forEach(function (val) {

            if (data[1].sender == val.GetReceiver)
              if (data[1].isTyping == 1) {
                Vue.set(val, 'typing_text', this.$t('isTyping'))
              } else {
                Vue.set(val, 'typing_text', null)

              }
          });

        }
        //************************************
        if (data[0] == 'get_message') {

          this.fConversations.forEach(function (val) {

            if (data[1].ReceiverId == val.GetReceiver || data[1].CurrentUserId == val.GetReceiver)
              Vue.set(val, 'MessageText', data[1].Message)
            if (data[1].CurrentUserId == val.GetReceiver) {
              Vue.set(val, 'UnReadCount', val.UnReadCount + 1)

            }
          });

        }
        //************************************
      })
      window.addEventListener('resize', this.resize_mobile, { passive: true })
      this.resize_mobile()

    },
    watch: {
      searchQuery: function (val) {
        this.resultQuery();
      },
      'window.width':function(){
        console.log("widht is",window.innerWidth)
      }
    },
    computed: {},
    methods: {
      resize_mobile() {
        if(window.innerWidth < 600) {
          this.isMobile= true
        } else {
          this.isMobile= false
        }
      },
      removeMessage() {
        this.dialog = true;
      },

      openMenu(e, item) {
        console.log("open", item);
        this.show_detail = item;
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },


      resultQuery() {
        this.fConversations = this.conversations.filter(post => {
          return post.ProcessName.toLowerCase().includes(this.searchQuery)
        })
      },

      goToDetail(item) {
        console.log("iteem", item)
        Vue.set(item, 'UnReadCount', 0)

        const last_chat_detail = {
          "RecType": item.RecType,
          "UserOrGroupId": item.UserOrGroupId,
          "GetReceiver": item.GetReceiver
        }
        localStorage.setItem("lastChat", JSON.stringify(last_chat_detail))
        this.$router.push({name: $t('conversation'), params: {}})
      },

      get_all_conversations(page) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        var phone = localStorage.getItem("phone")
        phone = phone.replace("+98", "");
        var password = localStorage.getItem("password")
        const send_data = {
          "Phone": phone,
          "Password": password,
          "LastItemId": 0,
          "Row": page,
        };
        // X-Content-Type-Options: nosniff
        const headers = {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        }
        // this.axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff' // for all requests

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetConversation', send_data, {})
          .then(response => {
            if (response.data.error == 0) {

              this.date_now = response.data.dateNow


              if (page == 0) {
                self.conversations = response.data.conversation;
                self.fConversations = response.data.conversation;
              } else {
                response.data.conversation.forEach(function (number) {
                  self.conversations.push(number);
                  self.fConversations.push(number);
                });
                if (response.data.conversation.length == 10) {
                  page = page + 1;
                  this.get_all_conversations(page)
                }
              }
            } else {
              self.not_register = true;
            }
            // this.$router.push({ path: "/post-login", params: {} });

          }).catch(e => {
          // this.errors.push(e);

        })
      },
      convert_string_to_date(date){
        var dateString = date;

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/;
        var dateArray = reggie.exec(dateString);

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        var dateObject = new Date(
          (+dateArray[3]),
          (+dateArray[2]), // Careful, month starts at 0!
          (+dateArray[1]),
          (+dateArray[4]),
          (+dateArray[5]),
          (+dateArray[5])
        );
        return dateObject.toDateString()
      },
      get_conversation_date(item) {
        var date = item.SubmitDateTimeMiladi
        var days = 0;
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour = new Date(date)
        var reportDate = date.substring(date.length-5)

        days = dateNow - conv_date;

        days = days / (1000 * 60 * 60 * 24)

        var ret;
        if (days < 1) {
          ret = reportDate;
        } else if (days >= 1 && days < 2) {
          ret = this.$t('yesterday') + reportDate;
        } else if ((days < 8) && (days > 1)) {
          ret = parseInt(days) + this.$t('dayBefor') + (reportDate);

        } else {
          ret = item.SubmitDateTime.replace("-"," ");
        }

        return ret;
      },



      // get_conversation_date(date) {
      //   var days = 0;
      //   var dateNow = new Date(this.date_now)
      //   var conv_date = new Date(date)
      //
      //   var reportDate = conv_date.getHours() + ":" + conv_date.getMinutes()
      //   days = dateNow.getTime() - conv_date.getTime();
      //   days = days / (1000 * 60 * 60 * 24)
      //   var ret;
      //   if (days < 1) {
      //     ret = reportDate;
      //   } else if (days > 1 && days < 2) {
      //     ret = " دیروز " + reportDate;
      //   } else if ((days < 8) && (days > 1)) {
      //     ret = days + " روز قبل " + reportDate;
      //
      //   } else {
      //     ret = date;
      //   }
      //
      //   return ret;
      // },
      goToContact() {
        this.$router.push({path: '/contacts', params: {}})
      },
    }
  }
</script>
